import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export const UserSearchSkeleton = () => (
  <div className="flex min-w-72 flex-col">
    {[1, 2].map((index) => (
      <div
        className={cnTwMerge(
          "flex items-center gap-2 p-4",
          index === 1 && "border-b border-border/primary",
        )}
        key={index}
      >
        <div className="h-7 w-7 rounded-full skeleton-box" />
        <div className="flex flex-col flex-1">
          <div className="h-5 w-3/4 skeleton-box mb-1" />
          <div className="h-4 w-9/10 skeleton-box" />
        </div>
      </div>
    ))}
  </div>
);
